import { PartFinderReport } from '@/api/generatedApi';
import { BodyText } from '@/components/BodyText';
import { AutoAwesomeOutlined } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';

const Wrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  height: '100%',
  maxWidth: '100%',
  overflow: 'hidden',
});

const Text = styled(BodyText)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const TopRecommendationCell = ({ report }: { report: PartFinderReport }) => {
  if (report.finalRecommendation) {
    return (
      <Tooltip title={report.finalRecommendation} placement='top'>
        <Wrapper>
          <Text>{report.finalRecommendation}</Text>
        </Wrapper>
      </Tooltip>
    );
  }
  if (report.aiSuggestedRecommendation) {
    return (
      <Tooltip title={report.aiSuggestedRecommendation} placement='top'>
        <Wrapper>
          <AutoAwesomeOutlined fontSize='small' color='primary' />
          <Text>{report.aiSuggestedRecommendation}</Text>
        </Wrapper>
      </Tooltip>
    );
  }
  return <BodyText sx={{ color: 'text.secondary' }}>—</BodyText>;
};
